import MuiBackdrop, { BackdropProps as MuiBackdropProps } from '@mui/material/Backdrop';

const BLUR_IN_PIXELS = 4;

export interface BackdropProps extends Pick<MuiBackdropProps, 'open' | 'onClick'> {
  position?: 'absolute' | 'fixed';
  zIndex?: number;
}

const Backdrop = ({ open, onClick, position = 'fixed', zIndex }: BackdropProps) => {
  return (
    <MuiBackdrop
      open={open}
      onClick={onClick}
      sx={(theme) => ({
        position,
        zIndex,
        backgroundColor: theme.palette.custom.backdrop,
        backdropFilter: `blur(${BLUR_IN_PIXELS}px)`,
      })}
    />
  );
};

export default Backdrop;
